"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var StorageInterface_1 = __importDefault(require("./StorageInterface"));
var Logger_1 = __importDefault(require("../Logger"));
var BrowserStorage = /** @class */ (function () {
    function BrowserStorage() {
        var _this = this;
        this.upgradeNeeded = function (e) {
            Logger_1.default.log('Upgraded db', e);
            _this.db = e.target.result;
            if (_this.db) {
                _this.db.createObjectStore('settings');
            }
        };
        this.db = null;
    }
    BrowserStorage.prototype.connect = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.db) {
                resolve(true);
            }
            else {
                if (!indexedDB) {
                    reject(new Error('IndexedDB not supported'));
                    return;
                }
                var request = indexedDB.open('bredbandskollen', 1);
                request.onupgradeneeded = _this.upgradeNeeded;
                request.onerror = function (e) { return Logger_1.default.log('DB Error', e); };
                request.onupgradeneeded = _this.upgradeNeeded;
                request.onsuccess = function (e) {
                    Logger_1.default.log('Opened db', e);
                    _this.db = e.target.result;
                    resolve(true);
                };
                request.onerror = reject;
            }
        });
    };
    BrowserStorage.prototype.add = function (key, value) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.connect().then(function () {
                _this.get(key)
                    .then(function (result) {
                    if (!_this.db) {
                        reject(new Error('No DB connection'));
                        return;
                    }
                    var transaction = _this.db.transaction(['settings'], 'readwrite');
                    var objectStore = transaction.objectStore('settings');
                    if (result) {
                        var objectStoreRequest_1 = objectStore.put(value, key);
                        objectStoreRequest_1.onsuccess = function () { return resolve(objectStoreRequest_1.result); };
                        objectStoreRequest_1.onerror = reject;
                    }
                    else {
                        var objectStoreRequest_2 = objectStore.add(value, key);
                        objectStoreRequest_2.onsuccess = function () {
                            resolve(objectStoreRequest_2.result);
                        };
                        objectStoreRequest_2.onerror = reject;
                    }
                }).catch(reject);
            }).catch(reject);
        });
    };
    BrowserStorage.prototype.get = function (key) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.connect().then(function () {
                if (!_this.db) {
                    reject(new Error('No DB connection'));
                    return;
                }
                var transaction = _this.db.transaction(['settings'], 'readwrite');
                transaction.oncomplete = function (e) { return resolve(e); };
                transaction.onerror = reject;
                var objectStore = transaction.objectStore('settings');
                var objectStoreRequest = objectStore.get(key);
                objectStoreRequest.onsuccess = function () { return resolve(objectStoreRequest.result); };
                objectStoreRequest.onerror = reject;
            }).catch(reject);
        });
    };
    return BrowserStorage;
}());
exports.default = new BrowserStorage();
//# sourceMappingURL=BrowserStorage.js.map